define('lib/backbone/Backbone.PodioView',['require','underscore','jquery','backbone','backbone-super','underscore','lib/jquery/jquery.hotkeys','lib/prototype/String.prototype','lib/view_helpers/base','lib/view_helpers/time','lib/Podio.Push','lib/backbone/Backbone.PodioEvents','lib/Podio.Routes','lib/Podio.Utils','lib/Podio.Config','lib/Podio.Time','lib/Podio.Bootstrap','lib/backbone/Backbone.Mixins.Factory'],function (require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  require('backbone-super');
  require('underscore');
  require('lib/jquery/jquery.hotkeys');
  require('lib/prototype/String.prototype');

  var eventSplitter = /^(\S+)\s*(.*)$/;
  var defaultFlag = 'default ';

  var viewHelpers = require('lib/view_helpers/base');
  var timeViewHelpers = require('lib/view_helpers/time');
  var PodioPush = require('lib/Podio.Push');
  var PodioEvents = require('lib/backbone/Backbone.PodioEvents');

  var routes = require('lib/Podio.Routes');
  var podioUtils = require('lib/Podio.Utils');
  var podioConfig = require('lib/Podio.Config');
  var podioTime = require('lib/Podio.Time');

  var BootstrapMixin = require('lib/Podio.Bootstrap');
  var MixinFactory = require('lib/backbone/Backbone.Mixins.Factory');

  var shortcutBlocks = {};

  var PodioView = Backbone.View.extend({

    constructor: function(options){
      this._ensureEventBus(options);
      this._handleOptions(options);

      Backbone.View.prototype.constructor.apply(this, _.toArray(arguments));
    },

    initialize: function(options) {
      this.podioDelegateEvents();
      this.podioDelegatePush();
    },

    _handleOptions: function(options) {
      // reassign the options hash to the view for backwards compatibility, since it's been removed in Backbone 1.1.0
      if (this.options) {
        options = _.extend(this.options, options);
      }
      this.options = options || {};

      // assign the elm to the object
      if (options) {
        if (options.elm) {
          this.elm = options.elm;
        }

        // we don't want to use events passed into the options, since we have our own podioEvents
        delete options.events;
      }
    },

    _ensureElement: function() {

      if( !this.el && this.elm ) {
        this.el = this.elm[0];
      }

      this._super();

    },

    // Change the view's element (`this.el` property), including event re-delegation.
    // This method should probably be aligned with backbone.setElement;
    setElement: function(element, delegate) {

      if (this.elm) {
        this.podioUndelegateEvents();
      }

      if(this.$el) {
        this.undelegateEvents();
      }

      this.elm = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.$el = this.elm;
      this.el = this.elm[0];

      if (delegate !== false) {
        this.delegateEvents();
        this.podioDelegateEvents();
      }

      return this;
    },

    _ensureEventBus: function(options) {
      if(options && options.eventBus) {
        this.eventBus = options.eventBus;
      }
    },

    bindAll: function() {
      _.bindAll.apply(this, [this].concat( _.toArray(arguments) ) );
    },

    showFeature: function(featureName) {
      return podioUtils.showFeature(featureName);
    },

    destroy: function() {
      this.podioUndelegateEvents();
      this.podioUndelegatePush();
      this.stopListening();
    },

    dispose: function() {
      this.disableShortcuts();
      this.podioUndelegateEvents();
      this.podioUndelegatePush();
      this.remove();
    },

    delegateEventsProxyCallback: function(callback, shouldPreventDefault, e) {

      var elmTarget = $(e.currentTarget);

      if (shouldPreventDefault) {
        e.preventDefault();
      }

      callback.apply(this, [elmTarget].concat( _.toArray(arguments).slice(2) ) );
    },

    delegateShortcutProxyCallback: function(callback, key, e) {
      var last = _.last(shortcutBlocks[key]);
      if(last && last != this.cid) {
        return;
      }

      e.preventDefault();

      callback.apply(this, [$(e.currentTarget)].concat(_.toArray(arguments).slice(2)));
    },

    podioDelegateEvents : function(events) {
      if (!(events || (events = this.podioEvents))) {
        return;
      }

      if (_.isFunction(events)) {
        events = events.call(this);
      }

      $(this.el).unbind('.podioDelegateEvents' + this.cid);

      Object.keys(events).forEach(function (key) {
        var method = this[events[key]];

        if (!method) {
          throw new Error('Event "' + events[key] + '" does not exist');
        }

        var match = key.match(eventSplitter);
        var eventName = match[1];
        var selector = match[2];
        var shouldPreventDefault = true;

        // Parsing 'default' our of selector, to allow default behaviour
        if( match[2].startsWith( defaultFlag ) ) {
          shouldPreventDefault = false;
          selector = match[2].substr( defaultFlag.length );
        }

        var proxyMethod = _.bind(this.delegateEventsProxyCallback, this, method, shouldPreventDefault);

        eventName += '.podioDelegateEvents' + this.cid;

        if (selector === '') {
          $(this.el).bind(eventName, proxyMethod);
        } else {
          $(this.el).delegate(selector, eventName, proxyMethod);
        }
      }.bind(this));
    },

    podioUndelegateEvents: function() {
      $(this.el).unbind().undelegate('.podioDelegateEvents'+this.cid);
    },

    getTemplate : function(templateFunc, data) {
      var defaultModules = {
        routes: routes,
        podioUtils: podioUtils,
        podioConfig: podioConfig,
        podioTime: podioTime
      };
      data = _.extend({}, viewHelpers, defaultModules, data);

      return templateFunc(data);
    },

    podioDelegatePush: function() {
      if (!this.pushEvents) {
        return;
      }

      var self = this;

      _.each(this.pushEvents, function(refEvents, refType) {
        _.each(refEvents, function(callbackStr, value) {
          var values = value.split(' ');
          var eventName = values[0];
          var ignoreOwn = values[1] === 'ignoreOwn';

          PodioPush.on(refType, eventName, self[callbackStr], ignoreOwn);
        });
      });
    },

    podioUndelegatePush: function() {
      if (this.pushEvents) {
        var self = this;

        _.each(this.pushEvents, function(refEvents, refType) {
          _.each(refEvents, function(callbackStr, eventName) {
            PodioPush.off(refType, eventName, self[callbackStr]);
          });
        });
      }

      delete this.pushService;
    },

    getTemplateAsElement: function(key, data) {
      return $(this.getTemplate(key, data || {}));
    },

    renderTemplate: function(key) {
      return this.getTemplate(key, this.modelValues());
    },

    modelValues: function() {
      var self = this;
      var values = $.extend(true, {}, this.model.toJSON());

      _(this.renderMap).each(function(datatype, selector) {
        var splittedKeys = selector.split('.');
        var lastKey = splittedKeys[splittedKeys.length-1];
        var valuesParent = _.keypathValueOwner(values, selector);

        if (valuesParent && valuesParent[lastKey]) {
          valuesParent[lastKey] = self.convert(valuesParent[lastKey], datatype);
        }
      });
      return values;
    },

    convert: function(value, type) {
      switch(type) {
        case 'relativeDate':
          return timeViewHelpers.timestamp(_.escape(value));
        case 'formattedDate':
          return timeViewHelpers.absoluteTimestamp(_.escape(value));
        case 'formattedDateTime':
          return timeViewHelpers.absoluteDateTime(_.escape(value));
        case 'image':
          return viewHelpers.image_url_for(value, 'medium');
        case 'imageSmall':
          return viewHelpers.image_url_for(value, 'small');
        case 'imageTiny':
          return viewHelpers.image_url_for(value, 'tiny');
        case 'imageLarge':
          return viewHelpers.image_url_for(value, 'large');
        case 'imageBadge':
          return viewHelpers.image_url_for(value, 'badge');
      }
    },

    enableShortcuts: function() {
      if (_.isUndefined(this.shortcuts)) {
        return;
      }

      this.disableShortcuts(); // To avoid double bindings

      var elmDocument = $(document);

      Object.keys(this.shortcuts).forEach(function (trigger) {
        var modifierKey = this.parseShortcutTrigger(trigger);

        var method = this[this.shortcuts[trigger]];
        var proxyMethod = _.bind(this.delegateShortcutProxyCallback, this, method, modifierKey.key);

        if (modifierKey.modifier === "block") {
          if (_.isUndefined(shortcutBlocks[modifierKey.key])) {
            shortcutBlocks[modifierKey.key] = [this.cid];
          } else {
            shortcutBlocks[modifierKey.key].push(this.cid);
          }
        }

        elmDocument.bind(this.shortcutsEventname, modifierKey.key, proxyMethod);
      }.bind(this));
    },

    disableShortcuts: function() {
      if (_.isUndefined(this.shortcuts)) {
        return;
      }

      this.shortcutsEventname = 'keydown.backboneshortcuts.{0}'.format(this.cid);

      Object.keys(this.shortcuts).forEach(function (trigger) {
        var modifierKey = this.parseShortcutTrigger(trigger);
        shortcutBlocks[modifierKey.key] = _.without(shortcutBlocks[modifierKey.key], this.cid);
      }.bind(this));

      var elmDocument = $(document);
      elmDocument.unbind(this.shortcutsEventname);
    },

    parseShortcutTrigger: function(trigger) {
      var s;
      if(trigger.indexOf(" ") !== -1) {
        s = trigger.split(" ");
      } else {
        s = [null, trigger];
      }

      return {
        key: s[1],
        modifier: s[0]
      };
    },

    enableDebugMode: function() {
      this.eventLogging = true;
    },

    disableDebugMode: function() {
      this.eventLogging = false;
    },

    getOption : function(optionName){
      if (!optionName){
        return;
      }

      var value;

      if (this.options && (optionName in this.options) && (this.options[optionName] !== undefined)) {
        value = this.options[optionName];
      } else {
        value = this[optionName];
      }

      return value;
    }

  });

  _.extend(PodioView.prototype, PodioEvents, BootstrapMixin, MixinFactory);

  return PodioView;

});

